import { render } from "./GeneralTable.vue?vue&type=template&id=69e6ffe4"
import script from "./GeneralTable.vue?vue&type=script&lang=js"
export * from "./GeneralTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__